import { Text, VStack, Link } from '@chakra-ui/react'
import { DownloadIcon, QuestionIcon } from '@chakra-ui/icons'

export const ImportPatientHelpGuide = () => {
  return (
    <VStack alignItems={'stretch'} paddingTop={2} paddingLeft={1} spacing={1}>
      <Text fontSize={'xs'} as="b">
        <QuestionIcon boxSize={3} marginBottom={1} /> First time using bulk import? Click{' '}
        <Link
          href="https://help.rxpad.com.au/en/articles/8320213-rxpad-bulk-patient-import-guide"
          isExternal
          target="_blank"
          color={'blue.500'}
        >
          here
        </Link>{' '}
        to view the Bulk Patient Import Guide for step-by-step instructions.
      </Text>
      <Text as={'b'} fontSize={'xs'}>
        <Link
          href="https://telecareaus.sharepoint.com/:x:/s/PRODRxPad/IQCRFQE2ZSq-TY42ZdNndvQ-AcVhQe8Z9Zz7If2Q4eSbmcA?rtime=vIiVVTg93kg"
          isExternal
          target="_blank"
          color={'blue.500'}
        >
          <DownloadIcon color={'blue.500'} boxSize={3} marginBottom={1} /> Patient Import Template
          (Editable).xlsx
        </Link>
      </Text>
      <Text as={'b'} fontSize={'xs'}>
        <Link
          href="https://telecareaus.sharepoint.com/:x:/s/PRODRxPad/IQC2fLzLmCabRb1QYlumVW7sAfLEug2xtvm7OY0hUf2C1yY?e=HfWgbL&wdOrigin=TEAMS-MAGLEV.null_ns.rwc&wdExp=TEAMS-TREATMENT&wdhostclicktime=1765954190323&web=1"
          isExternal
          target="_blank"
          color={'blue.500'}
        >
          <DownloadIcon color={'blue.500'} boxSize={3} marginBottom={1} /> Sample Patient Import
          (View Only).xlsx
        </Link>
      </Text>
    </VStack>
  )
}
